module.exports = __webpack_public_path__ + "static/media/star_unselected.aedfe0dc.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/star_unselected.svg
// module id = 365
// module chunks = 0